import {
  Component,
  computed,
  input,
} from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ClientDto } from '../../../../api';
import { Button } from 'primeng/button';
import { DataTableComponent } from '../../../../shared/components/data-table/data-table.component';
import { DataTableColumn } from '../../../../shared/components/data-table/data-table.types';

@Component({
  selector: 'app-client-list',
  standalone: true,
  imports: [DataTableComponent, TooltipModule, Button],
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.css',
})
export class ClientListComponent {
  clients = input<ClientDto[]>([]);

  isOwner = input.required<boolean>();
  readonly columns = computed<DataTableColumn[]>(() => [
    { label: 'Nazwa', sortField: 'name' },
    { label: 'Email', sortField: 'email' },
    { label: 'Telefon', sortField: 'phone' },
    ...(this.isOwner() ? [{ label: 'Akcje', headerAlign: 'right' as const }] : []),
  ]);
  loading = input.required<boolean>();
  totalRecords = input.required<number>();
  rows = input.required<number>();
  currentPage = input.required<number>();
  onLazyLoad = input.required<(event: TableLazyLoadEvent) => void>();
  onEditRequest = input<((client: ClientDto) => void) | null>(null);
  onDeleteRequest = input<((client: ClientDto) => void) | null>(null);

  requestEdit(client: ClientDto): void {
    this.onEditRequest()?.(client);
  }

  requestDelete(client: ClientDto): void {
    this.onDeleteRequest()?.(client);
  }
}
